module.exports = __webpack_public_path__ + "fonts/BEBAS___.3ef73ff4.TTF";